import { Link, useLocation, Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { LayoutDashboard, Package, Upload, Users, Truck, ShoppingCart, Settings, ArrowLeft, LogOut } from 'lucide-react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_rainforest-portal/artifacts/tketd0pp_AMAZONIA%20-%20Vertical%20Logo%20White%402x.png";

const navItems = [
  { to: '/admin', icon: LayoutDashboard, label: 'Tableau de bord', exact: true },
  { to: '/admin/products', icon: Package, label: 'Produits' },
  { to: '/admin/csv-import', icon: Upload, label: 'Import CSV' },
  { to: '/admin/suppliers', icon: Truck, label: 'Fournisseurs' },
  { to: '/admin/clients', icon: Users, label: 'Clients' },
  { to: '/admin/orders', icon: ShoppingCart, label: 'Commandes' },
];

export default function AdminLayout() {
  const { user, isAdmin, logout } = useAuth();
  const location = useLocation();

  if (!isAdmin) return <Navigate to="/login" replace />;

  return (
    <div data-testid="admin-layout" className="flex min-h-screen">
      {/* Sidebar */}
      <aside className="w-60 bg-[#111] text-white shrink-0 flex flex-col">
        <div className="p-4 border-b border-white/10">
          <img src={LOGO_URL} alt="Amazonia" className="h-10 w-auto mb-2" />
          <p className="text-xs text-white/40 uppercase tracking-wider">Administration</p>
        </div>
        <nav className="flex-1 py-2">
          {navItems.map((item) => {
            const isActive = item.exact ? location.pathname === item.to : location.pathname.startsWith(item.to);
            return (
              <Link
                key={item.to}
                to={item.to}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s/g, '-')}`}
                className={`flex items-center gap-3 px-4 py-2.5 text-sm transition-colors duration-200 ${
                  isActive ? 'bg-white/10 text-white font-semibold' : 'text-white/60 hover:text-white hover:bg-white/5'
                }`}
              >
                <item.icon size={16} />
                <span>{item.label}</span>
              </Link>
            );
          })}
        </nav>
        <div className="p-4 border-t border-white/10 space-y-2">
          <Link to="/" className="flex items-center gap-2 text-sm text-white/50 hover:text-white transition-colors duration-200">
            <ArrowLeft size={14} /> Retour au site
          </Link>
          <button onClick={logout} className="flex items-center gap-2 text-sm text-white/50 hover:text-[#E8231B] transition-colors duration-200">
            <LogOut size={14} /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 bg-white overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
